// src/pages/Friends.jsx
import "../assets/stylesheets/friends.css";

export default function Friends() {
  return (
    <>
      <section className="page-heading">
        <h1>Friends</h1>
        <p>See what your friends are listening to in real-time</p>
      </section>

      <div className="friend-requests-container">
        <button className="friend-requests-btn">Friend Requests ⬇</button>
        <div className="friend-requests-content hidden">
          <div className="requests-section">
            <h3>Incoming</h3>
          </div>
          <div className="requests-section">
            <h3>Outgoing</h3>
          </div>
        </div>
      </div>

      <div className="friend-search">
        <input
          type="text"
          className="search-bar"
          placeholder="Search for friends..."
        />
        <button className="nav-btn">Send Request</button>
      </div>

      <main className="profile-grid">{/* Map profiles here later */}</main>
    </>
  );
}
